export const AssetsLiabilitiesData = {
  clientId: "",
  propertyLocation1: "",
  propertyValue1: "",
  assetPropertyType1: "",
  propertyDebt1: "",
  propertyRent1: "",
  propertyLender1: "",
  propertyPayment1: "",
  propertyRate1: "",
  propertyRepay1: "",
  propertyType1: "",
  propertyDate1: "",
  propertyLVR1: "0",
  propertyEquity1: "0",
  propertyOwn1: "",
  propertyLocation2: "",
  assetPropertyType2: "",
  propertyValue2: "",
  propertyDebt2: "",
  propertyRent2: "",
  propertyLender2: "",
  propertyPayment2: "",
  propertyRate2: "",
  propertyRepay2: "",
  propertyType2: "",
  propertyDate2: "",
  propertyLVR2: "0",
  propertyEquity2: "0",
  propertyOwn2: "",
  purchased2: "",
  propertyLocation3: "",
  propertyValue3: "",
  propertyDebt3: "",
  propertyRent3: "",
  propertyLender3: "",
  propertyPayment3: "",
  propertyRate3: "",
  propertyRepay3: "",
  propertyType3: "",
  propertyLVR3: "0",
  propertyEquity3: "0",
  assetPropertyType3: "",
  purchased3: "",
  propertyLocation4: "",
  propertyValue4: "",
  propertyDebt4: "",
  propertyRent4: "",
  propertyLender4: "",
  propertyPayment4: "",
  propertyRate4: "",
  propertyRepay4: "",
  propertyType4: "",
  propertyLVR4: "0",
  propertyEquity4: "0",
  assetPropertyType4: "",
  purchased4: "",
  propertyLocation5: "",
  propertyValue5: "",
  propertyDebt5: "",
  propertyRent5: "",
  propertyLender5: "",
  propertyPayment5: "",
  propertyRate5: "",
  propertyRepay5: "",
  propertyType5: "",
  propertyLVR5: "0",
  propertyEquity5: "0",
  assetPropertyType5: "",
  purchased5: "",
  propertyLocation6: "",
  propertyValue6: "",
  propertyDebt6: "",
  propertyRent6: "",
  propertyLender6: "",
  propertyPayment6: "",
  propertyRate6: "",
  propertyRepay6: "",
  propertyType6: "",
  propertyLVR6: "0",
  propertyEquity6: "0",
  assetPropertyType6: "",
  purchased1: "",
  purchased6: "",
  totalPropertyValue: "0",
  totalPropertyDebt: "0",
  totalPropertyRent: "0",
  totalPropertyPayment: "0",
  totalPropertyLVR: "0",
  totalPropertyEquity: "0",
  motorVehicleOwner1: "",
  motorVehicleBodyType1: "",
  motorVehicleMake1: "",
  motorVehicleModal1: "",
  motorVehicleYear1: "",
  motorVehicleValue1: "",
  motorVehicleDebt1: "",
  motorVehicleLender1: "",
  motorVehicleRate1: "",
  motorVehiclePayment1: "",
  motorVehicleRefinance1: "",
  motorVehicleOwner2: "",
  motorVehicleBodyType2: "",
  motorVehicleMake2: "",
  motorVehicleModal2: "",
  motorVehicleYear2: "",
  motorVehicleValue2: "",
  motorVehicleDebt2: "",
  motorVehicleLender2: "",
  motorVehicleRate2: "",
  motorVehiclePayment2: "",
  motorVehicleRefinance2: "",
  motorVehicleTotalValue: "",
  motorVehicleTotalDebt: "",
  motorVehicleTotalPayment: "",
  liabilitiesType1: "",
  liabilitiesOwner1: "",
  liabilitiesLender1: "",
  liabilitiesLimit1: "",
  liabilitiesBalance1: "",
  liabilitiesRate1: "",
  liabilitiesPayment1: "",
  liabilitiesRefinance1: "",
  liabilitiesRate4: "",
  liabilitiesPayment4: "",
  liabilitiesRefinance4: "",
  liabilitiesTotalLimit: "",
  liabilitiesTotalBalance: "",
  liabilitiesTotalPayment: "",
  liabilitiesType2: "",
  liabilitiesOwner2: "",
  liabilitiesLender2: "",
  liabilitiesLimit2: "",
  liabilitiesBalance2: "",
  liabilitiesRate2: "",
  liabilitiesPayment2: "",
  liabilitiesRefinance2: "",
  liabilitiesType3: "",
  liabilitiesOwner3: "",
  liabilitiesLender3: "",
  liabilitiesLimit3: "",
  liabilitiesBalance3: "",
  liabilitiesRate3: "",
  liabilitiesPayment3: "",
  liabilitiesRefinance3: "",
  liabilitiesType4: "",
  liabilitiesOwner4: "",
  liabilitiesLender4: "",
  liabilitiesLimit4: "",
  liabilitiesBalance4: "",
  otherAssetsCashAndSavings: "",
  superApplicant1: "",
  superApplicant2: "",
  smsf: "",
  rentMonthly: ""
};

export const MotorVehiclesData = {
  motorVehicleOwner1: '',
  motorVehicleBodyType1: '',
  motorVehicleMake1: '',
  motorVehicleModal1: '',
  motorVehicleYear1: '',
  motorVehicleValue1: '',
  motorVehicleDebt1: '',
  motorVehicleLender1: '',
  motorVehicleRate1: '',
  motorVehiclePayment1: '',
  motorVehicleRefinance1: '',

  motorVehicleOwner2: '',
  motorVehicleBodyType2: '',
  motorVehicleMake2: '',
  motorVehicleModal2: '',
  motorVehicleYear2: '',
  motorVehicleValue2: '',
  motorVehicleDebt2: '',
  motorVehicleLender2: '',
  motorVehicleRate2: '',
  motorVehiclePayment2: '',
  motorVehicleRefinance2: '',

  motorVehicleTotalValue: '',
  motorVehicleTotalDebt: '',
  motorVehicleTotalPayment: ''
};

export const LiabilitiesData = {
  liabilitiesType1: '',
  liabilitiesOwner1: '',
  liabilitiesLender1: '',
  liabilitiesLimit1: '',
  liabilitiesBalance1: '',
  liabilitiesRate1: '',
  liabilitiesPayment1: '',
  liabilitiesRefinance1: '',

  liabilitiesRate4: '',
  liabilitiesPayment4: '',
  liabilitiesRefinance4: '',

  liabilitiesTotalLimit: '',
  liabilitiesTotalBalance: '',
  liabilitiesTotalPayment: '',

  liabilitiesType2: '',
  liabilitiesOwner2: '',
  liabilitiesLender2: '',
  liabilitiesLimit2: '',
  liabilitiesBalance2: '',
  liabilitiesRate2: '',
  liabilitiesPayment2: '',
  liabilitiesRefinance2: '',

  liabilitiesType3: '',
  liabilitiesOwner3: '',
  liabilitiesLender3: '',
  liabilitiesLimit3: '',
  liabilitiesBalance3: '',
  liabilitiesRate3: '',
  liabilitiesPayment3: '',
  liabilitiesRefinance3: '',

  liabilitiesType4: '',
  liabilitiesOwner4: '',
  liabilitiesLender4: '',
  liabilitiesLimit4: '',
  liabilitiesBalance4: '',
};

export const AssetsOthers = {
  otherAssetsCashAndSavings: "",
  superApplicant1: "",
  superApplicant2: "",
  smsf: "",
};

export const incomeExpenses = {
  id: "0",
  clientId: "",
  clientName1Income: '',
  clientName2Income: '',
  investmentNetAfterTax: '',
  otherIncomeAfterTax: '',
  totalIncomeAfterTax: '',
  expensesLiving: '',
  motorVehiclesloanRepayments: '',
  loanRepayments : '',
  otherLiabilitiesloanRepayments : '',
  totalExpenses: '',
  savingsForInvestment: '',
  targetSavingsRate: '',
  actualSavingsRate: '',
  expenseLivingPercent : '',
  loanRepaymentHomePercent : '',
  loanRepaymentMotorVehicalPercent : '',
  loanRepaymentsOtherLiabilitiesPercent : '',
  guid: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
  result :''
};